const relatorio_de_reordenamento = {
  path: "/relatorio-de-reordenamento",
  redirect: "/relatorio-de-reordenamento",
  meta: {
    breadCrumb: "Processo de Matrículas - Registrar Reordenamento",
  },
  children: [
    {
      path: "/relatorio-de-reordenamento",
      name: "relatorio_de_reordenamento",
      component: () =>
        import(
          "@/views/RelatorioDeReordenamento/RelatorioDeReordenamentoHome.vue"
        ),
    },
  ],
};

export { relatorio_de_reordenamento };
